import { useDocument } from '../api';
import { useParams } from 'react-router-dom';
import { StatusLabel } from '@shared/components';
import { DocumentProvider } from '../contexts/DocumentContext.context';
import { useBlockCtrlS } from '@shared/hooks';

const Document = () => {
  const { id } = useParams(); // Access the dynamic part of the route
  const { error, data } = useDocument(id as string); // id is always filled, otherwise NoPage.tsx is rendered

  useBlockCtrlS();

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading document..."
      error={error}
      errorMessage="Loading document failed!"
      render={(data) => (
        <DocumentProvider
          doc={data.doc}
          permissions={data.permissions}
          resolvedItems={data.resolvedItems}
          resolvedItemNames={data.resolvedItemNames}
        />
      )}
    />
  );
};

export default Document;
